import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Modal,
  Checkbox,
  Upload,
  message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import API_MANAGER from "../../../API";
import axios from "axios";
import { s3PreUrl } from "../../../constants";

function AddQualification({
  setAddQualification,
  addQualification,
  qualification,
  licenceType,
  profileId,
  stateTags,
  onSuccess,
  existingQualifications,
  onReplaceQualification
}) {
  const [qualificationFrom] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [fileListBack, setFileListBack] = useState([]);
  const [showSOA, setShowSOA] = useState(false);
  const [showVOC, setShowVOC] = useState(false);
  const [fileListSOA, setFileListSOA] = useState([]);
  const [fileListVOC, setFileListVOC] = useState([]);
  const [vocTypes, setVocTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [duplicateModalVisible, setDuplicateModalVisible] = useState(false);
  const [duplicateQualification, setDuplicateQualification] = useState(null);

  const getVocTypes = async () => {
    try {
      const response = await API_MANAGER.getPickListTags({
        type: "VOC",
        limit: 2000,
        sort: "name",
      });
      setVocTypes(response?.data?.data?.tags);
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  const getCountries = async () => {
    try {
      const response = await API_MANAGER.getPickListTags({
        type: "COUNTRY",
        limit: 2000,
        sort: "name",
      });
      setCountries(response?.data?.data?.tags || []);
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  useEffect(() => {
    getVocTypes();
    getCountries();
  }, []);

  const handleDocument = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    qualificationFrom.setFieldsValue({
      uploadedDocument: newFileList.length > 0 ? newFileList : undefined
    });
    qualificationFrom.validateFields(['uploadedDocument']);
  };
  const handleBackDocument = ({ fileList: newFileList }) => {
    setFileListBack(newFileList);
  };
  const handleSOADocument = ({ fileList: newFileList }) => {
    setFileListSOA(newFileList);
    qualificationFrom.setFieldsValue({
      SOADocument: newFileList.length > 0 ? newFileList : undefined
    });
    qualificationFrom.validateFields(['SOADocument']);
  };
  const handleVOCDocument = ({ fileList: newFileList }) => {
    setFileListVOC(newFileList);
    qualificationFrom.setFieldsValue({
      VOCDocument: newFileList.length > 0 ? newFileList : undefined
    });
  };
  const props = {
    name: "file",
    accept: "image/jpg,image/jpeg,.pdf",
    multiple: false,
    listType: "text",
    showUploadList: {
      showPreviewIcon: false,
      showRemoveIcon: true,
      showDownloadIcon: false,
    },
    customRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  const checkDuplicate = (qualificationTypeId) => {
    if (!existingQualifications || !qualificationTypeId) {
      return null;
    }
    return existingQualifications.find(
      (qual) => qual?.qualificationType?._id === qualificationTypeId || 
                qual?.qualificationType?.id === qualificationTypeId
    );
  };

  const onFinish = async (values) => {
    // This function only runs if validation passes
    // If validation fails, onFinishFailed will be called instead
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      //Upload Doc
      const dataQualification = {
        extension: fileList?.length > 0 ? fileList[0]?.type.split("/")[1] : "",
        type: "DOCUMENT",
        name: fileList?.length > 0 ? fileList[0].originFileObj.name : '',
        contentType: fileList?.length > 0 ? fileList[0]?.type : "",
      };
      const responseQualification = await API_MANAGER.fileUpload(dataQualification);
      await axios.put(
        responseQualification?.data?.data?.url,
        fileList[0]?.originFileObj
      );
      values.uploadedDocument = fileList?.length > 0 ? s3PreUrl + responseQualification.data?.data?.key : '';
      //Upload Back Doc
      const dataQualificationBack = {
        extension: fileListBack?.length > 0 ? fileListBack[0]?.type.split("/")[1] : "",
        type: "DOCUMENT",
        name: fileListBack?.length > 0 ? fileListBack[0].originFileObj.name : '',
        contentType: fileListBack?.length > 0 ? fileListBack[0]?.type : "",
      };
      const responseQualificationBack = await API_MANAGER.fileUpload(dataQualificationBack);
      await axios.put(
        responseQualificationBack?.data?.data?.url,
        fileListBack[0]?.originFileObj
      );
      values.uploadedDocumentBack = fileListBack?.length > 0 ? s3PreUrl + responseQualificationBack.data?.data?.key : '';
      //SOA Doc
      const dataSOA = {
        extension: fileListSOA?.length > 0 ? fileListSOA[0]?.type.split("/")[1] : "",
        type: "DOCUMENT",
        name: fileListSOA?.length > 0 ? fileListSOA[0].originFileObj.name : '',
        contentType: fileListSOA?.length > 0 ? fileListSOA[0]?.type : "",
      };
      const responseSOA = await API_MANAGER.fileUpload(dataSOA);
      await axios.put(
        responseSOA?.data?.data?.url,
        fileListSOA[0]?.originFileObj
      );
      values.SOADocument = fileListSOA?.length > 0 ? s3PreUrl + responseSOA.data?.data?.key : '';
      //VOC Doc
      const dataVOC = {
        extension: fileListVOC?.length > 0 ? fileListVOC[0]?.type.split("/")[1] : "",
        type: "DOCUMENT",
        name: fileListVOC?.length > 0 ? fileListVOC[0].originFileObj.name : '',
        contentType: fileListVOC?.length > 0 ? fileListVOC[0]?.type : "",
      };
      const responseVOC = await API_MANAGER.fileUpload(dataVOC);
      await axios.put(
        responseVOC?.data?.data?.url,
        fileListVOC[0]?.originFileObj
      );
      values.hasSOA=showSOA;
      values.hasVOC=showVOC;
      values.VOCDocument = fileListVOC?.length > 0 ? s3PreUrl + responseVOC.data?.data?.key : '';
      values.profileId = profileId;
      await API_MANAGER.createCandidateQualification(values);
      message.success('Successfully added qualification');
      qualificationFrom.resetFields();
      setAddQualification(false);
      setIsSubmitting(false);
      if (onSuccess) {
        setTimeout(() => {
          onSuccess();
        }, 300);
      }
    } catch (error) {
      // This is a backend error
      setIsSubmitting(false);
      message.error(error.response?.data?.message?.message || 'An error occurred');
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form validation failed:', errorInfo);
    console.log('Error fields:', errorInfo.errorFields);
    // The validation messages will automatically appear below the fields
    // No API call will be made
    message.error('Please fill in all mandatory fields');
  };

  return (
    <>
      <Modal
        centered
        footer={false}
        open={addQualification}
        title={"Qualification Add"}
        className="resumeModal"
        onCancel={() => setAddQualification(false)}
      >
        <Form 
          form={qualificationFrom} 
          layout="vertical" 
          requiredMark={false}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          validateTrigger="onSubmit"
        >
          <Row className="containner">
            <Col xs={18}>
              <Form.Item
                label="Qualification/Certification/Ticket/Licence*"
                name="qualificationType"
                rules={[
                  {
                    required: true,
                    message: "Please select qualification type",
                  },
                ]}
              >
                <Select 
                  className="" 
                  placeholder="Qualification"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(value) => {
                    if (value) {
                      const duplicateQual = checkDuplicate(value);
                      if (duplicateQual) {
                        setDuplicateQualification(duplicateQual);
                        setDuplicateModalVisible(true);
                      }
                    }
                  }}
                >
                  {qualification?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e?.id}>
                        {e?.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row className="containner">
            <Col xs={18}>
              <Form.Item
                label="Document*"
                name="uploadedDocument"
                rules={[
                  {
                    validator: () => {
                      if (fileList.length === 0) {
                        return Promise.reject(new Error('Please upload document'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Upload {...props} onChange={handleDocument}>
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
          <Row className="containner">
            <Col xs={18}>
              <Upload {...props} onChange={handleBackDocument}>
                <Button icon={<UploadOutlined />}>Upload Back Document</Button>
              </Upload>
            </Col>
          </Row>
          <Row className="containner" gutter={24}>
            <Col xs={12}>
              <Form.Item 
                label="Member No./ID*" 
                name="memberId"
                rules={[
                  {
                    required: true,
                    message: "Please enter member ID",
                  },
                ]}
              >
                <Input placeholder="Member no./id" />
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item
                label="Licence Type/Class/Category"
                name="licenceType"
              >
                <Select
                  className=""
                  mode="multiple"
                  maxTagCount="responsive"
                  placeholder="Licence Type/Class/Category"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {licenceType?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e.id}>
                        {e.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item 
                label="State/Country*" 
                name="stateOrCountry"
                rules={[
                  {
                    required: true,
                    message: "Please select state/country",
                  },
                ]}
              >
                <Select
                  className=""
                  maxTagCount="responsive"
                  placeholder="State/Country"
                  showSearch
                  filterOption={(input, option) => {
                    const searchText = input.toLowerCase().trim();
                    if (!searchText) return true;
                    
                    const optionValue = String(option?.value || '').toLowerCase();
                    if (optionValue.indexOf(searchText) >= 0) {
                      return true;
                    }
                    
                    if (option?.children) {
                      if (typeof option.children === 'string') {
                        return option.children.toLowerCase().indexOf(searchText) >= 0;
                      }
                      if (React.isValidElement(option.children)) {
                        const childrenText = String(option.children.props?.children || '');
                        if (childrenText.toLowerCase().indexOf(searchText) >= 0) {
                          return true;
                        }
                      }
                    }
                    
                    return false;
                  }}
                >
                  <Select.OptGroup 
                    label={<span style={{ color: '#000', fontWeight: 'bold' }}>State</span>}
                  >
                    {stateTags?.map((e, key) => {
                      return (
                        <Select.Option key={`state-${key}`} value={e.name}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                  </Select.OptGroup>
                  <Select.OptGroup 
                    label={<span style={{ color: '#000', fontWeight: 'bold' }}>Country</span>}
                  >
                    {countries?.map((e, key) => {
                      return (
                        <Select.Option key={`country-${key}`} value={e.name}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                  </Select.OptGroup>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item 
                label="Issue Date" 
                name="issueDate"
                dependencies={['expiryDate']}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const expiryDate = getFieldValue('expiryDate');
                      if (!value && !expiryDate) {
                        return Promise.reject(new Error('Please select at least issue date or expiry date'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  className="w-100"
                  format={"DD-MM-YYYY"}
                  placeholder="Select issue date"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item 
                label="Expiry Date" 
                name="expiryDate"
                dependencies={['issueDate']}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const issueDate = getFieldValue('issueDate');
                      if (!value && !issueDate) {
                        return Promise.reject(new Error('Please select at least issue date or expiry date'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  className="w-100"
                  format={"DD-MM-YYYY"}
                  placeholder="Select expiry date"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item name="hasSOA">
                <Checkbox
                  checked={showSOA}
                  onChange={() => {
                    const newValue = !showSOA;
                    setShowSOA(newValue);
                    if (newValue) {
                      setTimeout(() => {
                        qualificationFrom.validateFields(['SOADocument']);
                      }, 0);
                    } else {
                      setFileListSOA([]);
                      qualificationFrom.setFieldsValue({ SOADocument: undefined });
                      qualificationFrom.validateFields(['SOADocument']);
                    }
                  }}
                >
                  Statement of Attainment
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
          {showSOA && (
            <Row className="containner">
              <Col xs={24}>
                <Form.Item
                  label="SOA Document*"
                  name="SOADocument"
                  dependencies={['hasSOA']}
                  rules={[
                    {
                      validator: () => {
                        if (showSOA && fileListSOA.length === 0) {
                          return Promise.reject(new Error('Please upload SOA document'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Upload {...props} onChange={handleSOADocument}>
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={12}>
                <Form.Item 
                  label="Issue Date*" 
                  name="SOAIssueDate"
                  rules={[
                    {
                      required: showSOA,
                      message: "Please select SOA issue date",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format={"DD-MM-YYYY"}
                    placeholder="Select issue date"
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={12}>
              <Form.Item name="hasVOC">
                <Checkbox
                  checked={showVOC}
                  onChange={() => {
                    const newValue = !showVOC;
                    setShowVOC(newValue);
                    if (newValue) {
                      setTimeout(() => {
                        qualificationFrom.validateFields(['VOCDocument']);
                      }, 0);
                    } else {
                      setFileListVOC([]);
                      qualificationFrom.setFieldsValue({ VOCDocument: undefined });
                      qualificationFrom.validateFields(['VOCDocument']);
                    }
                  }}
                >
                  Verification of Competency
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
          {showVOC && (
            <Row className="containner">
              <Col xs={24}>
                <Form.Item
                  label="VOC Document*"
                  name="VOCDocument"
                  dependencies={['hasVOC']}
                  rules={[
                    {
                      validator: () => {
                        if (showVOC && fileListVOC.length === 0) {
                          return Promise.reject(new Error('Please upload VOC document'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Upload {...props} onChange={handleVOCDocument}>
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
          )}
          {showVOC && (
            <Row gutter={24} style={{ marginTop: "10px" }}>
              <Col xs={12}>
                <Form.Item 
                  label="VOC Type*" 
                  name="VOCType"
                  rules={[
                    {
                      required: showVOC,
                      message: "Please select VOC type",
                    },
                  ]}
                >
                  <Select
                    className=""
                    placeholder="Select VOC Type"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {vocTypes?.map((e, key) => {
                      return (
                        <Select.Option key={key} value={e.id}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12}>
                <Form.Item 
                  label="Issue Date*" 
                  name="VOCIssueDate"
                  rules={[
                    {
                      required: showVOC,
                      message: "Please select VOC issue date",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format={"DD-MM-YYYY"}
                    placeholder="Select issue date"
                    // style={{ height: "38px" }}
                    // onChange={(e, date) => {setStartDate(e,date)}}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={24} className="buttonCol">
              <Button className="btn1" htmlType="submit">
                Create
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        className="candidateDeleteModal"
        centered
        open={duplicateModalVisible}
        onCancel={() => {
          setDuplicateModalVisible(false);
          setDuplicateQualification(null);
          qualificationFrom.setFieldsValue({ qualificationType: undefined });
        }}
        footer={null}
        title="Duplicate Qualification"
      >
        <Row className="header">
          <Col>
            <p className="desc">
              This qualification already exists.
              <br />
             Do you want to edit the existing qualification or cancel to add another qualification.
            </p>
          </Col>
        </Row>

        <Row align={"middle"} gutter={16} justify={"end"}>
          <Col>
            <Button
              className="cancelBtn"
              onClick={() => {
                setDuplicateModalVisible(false);
                setDuplicateQualification(null);
                qualificationFrom.setFieldsValue({ qualificationType: undefined });
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              className="confirmBtn"
              onClick={() => {
                setDuplicateModalVisible(false);
                setAddQualification(false);
                if (onReplaceQualification && duplicateQualification) {
                  onReplaceQualification(duplicateQualification);
                }
                setDuplicateQualification(null);
              }}
            >
              Edit
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
}
export default AddQualification;
